import n from"./classof-raw.js";import o from"./function-uncurry-this.js";var u=n,a=o,i=function(r){if(u(r)==="Function")return a(r)};export{i as default};
